module.exports = __webpack_public_path__ + "img/gartek-portfolio-plans-review-inspections.385b8f48.jpeg";